import { UniqueKeyGenerator } from '../../../hooks/useUniqueKey'
import {
  generateAddFormFieldButton,
  generateAddSectionTitleButton,
  generateSectionTitle,
  generateTextField,
} from '../../FormEditor/utils/functions'
import { EditorFieldObject } from '../../FormEditor/utils/types'

/**
 * Generates and returns a feedback form suggestion based on the provided (scale) quantities.
 *
 * For each quantity in the list, the following fields are generated:
 *  - Offer (Price, currency is required)
 *  - Delivery time
 *  - Shipping cost
 *
 * Adittionally there are two multiline input fields:
 *  - Offer a different scale quantity
 *  - General remarks
 * @param quantities Array of (scale) quantities
 */
export function buildFeedbackFormSuggestion(
  quantities: number[] | string[],
  uniqueKeyGenerator: UniqueKeyGenerator
): EditorFieldObject[] {
  // parse quantites
  let parsedQuantities: number[]
  if (quantities.every(qty => typeof qty === 'string')) {
    parsedQuantities = quantities.map(Number)
  } else parsedQuantities = quantities
  // sort quantites ascending
  parsedQuantities.sort((a: number, b: number) => a - b)

  // generate EditorFieldObjects
  const quantityFields: EditorFieldObject[] = []
  // add quantity related fields
  parsedQuantities.forEach(qty => {
    const pcsString = `${qty} ${qty > 1 ? 'Pcs.' : 'Pc.'}`
    quantityFields.push(
      generateSectionTitle(uniqueKeyGenerator.get(), `For ${pcsString} :`),
      generateTextField(uniqueKeyGenerator.get(), `Price (${pcsString})`, true),
      generateTextField(uniqueKeyGenerator.get(), `Delivery time (${pcsString})`, true),
      generateTextField(uniqueKeyGenerator.get(), `Shipping cost (${pcsString})`, true)
    )
  })

  const remarkFields = [
    generateSectionTitle(uniqueKeyGenerator.get(), 'Suggest a different scale quantity :'),
    generateTextField(uniqueKeyGenerator.get(), 'Suggestions', false, true),
    generateSectionTitle(uniqueKeyGenerator.get(), 'Further remarks: '),
    generateTextField(uniqueKeyGenerator.get(), 'Remarks', false, true),
  ]

  return [
    ...quantityFields,
    ...remarkFields,
    generateAddFormFieldButton(),
    generateAddSectionTitleButton(),
  ]
}
